var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteStack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_664_27526",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_664_27526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08324 11.6666V5.23532C4.08324 4.91449 4.19991 4.64227 4.43324 4.41866C4.66657 4.19504 4.94366 4.08324 5.26449 4.08324H11.6666C11.9874 4.08324 12.2621 4.19748 12.4905 4.42595C12.719 4.65442 12.8332 4.92907 12.8332 5.24991V9.91657L9.91657 12.8332H5.24991C4.92907 12.8332 4.65442 12.719 4.42595 12.4905C4.19748 12.2621 4.08324 11.9874 4.08324 11.6666ZM1.18116 3.64574C1.12282 3.32491 1.18602 3.03567 1.37074 2.77803C1.55546 2.52039 1.80824 2.36241 2.12907 2.30407L8.45824 1.18116C8.77907 1.12282 9.06831 1.18602 9.32595 1.37074C9.58359 1.55546 9.74157 1.80824 9.79991 2.12907L9.94574 2.91657H8.74991L8.64782 2.33324L2.33324 3.45616L2.91657 6.75199V10.8207C2.76102 10.7332 2.62734 10.6166 2.51553 10.4707C2.40373 10.3249 2.33324 10.1596 2.30407 9.97491L1.18116 3.64574ZM5.24991 5.24991V11.6666H9.33324V9.33324H11.6666V5.24991H5.24991Z",
    fill: "#EFB100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteStack);
export default __webpack_public_path__ + "static/media/note_stack.b2928a3235cc9bd7bcef608321630d8b.svg";
export { ForwardRef as ReactComponent };